import { render, staticRenderFns } from "./NavSidebar.vue?vue&type=template&id=716dc57d&scoped=true&"
import script from "./NavSidebar.vue?vue&type=script&lang=ts&"
export * from "./NavSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./NavSidebar.vue?vue&type=style&index=0&id=716dc57d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716dc57d",
  null
  
)

export default component.exports